import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SitefinityContentService } from '../services/settings/sitefinity-content.service';
import { PersistanceStrategyService } from '../services/persistant-strategy.service';
import { SitefinityService } from '../services/sitefinity.service';
import { ResourcesLoaderService, ADPResourceService } from 'digital-core';
import { PGHAppLoadService } from '../services/pgh-app-load.service';

@Injectable({
  providedIn: 'root'
})
export class PageResourcesResolver  {
  firstLoad = true;
  constructor(
    private sitefinityContentService: SitefinityContentService,
    private persistanceStrategyService: PersistanceStrategyService,
    private sitefinityService: SitefinityService,
    private route: ActivatedRoute,
    private loadService: PGHAppLoadService,
    private resourcesLoader: ResourcesLoaderService,
    public resourceService: ADPResourceService,
    public adpResourceService: ADPResourceService
  ) { }

  uriOrigin: string;

  async resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot) {
    let components = route.data['sfresources'];
    if (!components) {
      //throw new Error(`There is no Components associated to the route: ${route.url}`);
      components = 'Global,Modal,Login';
    }

    if (route.routeConfig.path == '' || route.routeConfig.path == 'login') {
      var data =  await this.loadService.loadSiteResources();
    }
    //return data;

    try {
      var adpresources = await this.resourcesLoader.loadAllPageResources(components, false, this.firstLoad).toPromise();
      
      this.resourceService.setGlobalResources(adpresources.resources);
      this.resourceService.setGlobalLabels(adpresources.labels);
      this.resourceService.setPortalPageList(adpresources.lists);

      this.adpResourceService.setGlobalResources(adpresources.resources);
      this.adpResourceService.setGlobalLabels(adpresources.labels);
      this.adpResourceService.setPortalPageList(adpresources.lists);
      this.adpResourceService.setPortalList(this.resourceService.lists);
      this.adpResourceService.setGlobalImages(this.resourceService.images);
      this.adpResourceService.setGlobalSettings(this.resourceService.settings);

      this.loadService.isSiteResourcesLoaded.next(true);
      // this.adpResourceService = this.resourceService;

      this.firstLoad = false;
      // return adpresources;
    }
    catch (e ) {
      console.log(e);
      return null;
    }

    const params: any = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop: any) => searchParams.get(prop),
    });

    this.uriOrigin = params?.origin ? params?.origin?.toLowerCase()?.trim() : '';

    const component: string = route.data.component;
    const loadGlobal: boolean = route.data.loadGlobal;

    let resources;
    if (loadGlobal) {
      //await this.loadHeaderFooterLogo();
    }
    if (component && !this.doesCacheDataExist(component)) {
      switch (component) {
        
        case 'DashboardPage':
          resources = await this.sitefinityService.getDashboardPage();
          break;
        case 'FileAClaimPage':
          resources = await this.sitefinityService.getFileAClaimPage();
          break;
        default:
          resources = null;
      }

      this.persistanceStrategyService.persistItem(component, resources);
      this.sitefinityContentService.setSettings({ [component]: resources });
    }
    if(route.routeConfig.path == '' || route.routeConfig.path == 'login')
      return data;
    else
      return adpresources;
    //return resources;
  }

 
  doesCacheDataExist(component: string): boolean {
    const cacheData = this.persistanceStrategyService.getItem(component);

    if (cacheData) {
      this.sitefinityContentService.setSettings(JSON.parse(JSON.stringify(cacheData)));

      return true;
    }

    return false;
  }
}
